module.exports = __webpack_public_path__ + "images/Flag_of_the_United_States.png";